var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpecificationIcon = function SvgSpecificationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.989,
    height: 85.153,
    viewBox: "0 0 72.989 85.153",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ca0928;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1450.829-1181.064v-60.824h8.11v12.165h32.439v-12.165h8.109v20.6a28.5,28.5,0,0,1,8.11,2.433v-23.032a8.134,8.134,0,0,0-8.11-8.11h-12.894a12.207,12.207,0,0,0-11.435-8.11,12.206,12.206,0,0,0-11.435,8.11h-12.895a8.134,8.134,0,0,0-8.11,8.11v60.824a8.133,8.133,0,0,0,8.11,8.109h24.776a27.327,27.327,0,0,1-5.758-8.109ZM-1426.5-1250a4.067,4.067,0,0,1,4.055,4.055,4.067,4.067,0,0,1-4.055,4.055,4.067,4.067,0,0,1-4.055-4.055A4.067,4.067,0,0,1-1426.5-1250Z",
    transform: "translate(1458.939 1258.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1387.565-1187.846a20.282,20.282,0,0,0-20.275,20.275,20.282,20.282,0,0,0,20.275,20.274,20.282,20.282,0,0,0,20.275-20.274A20.282,20.282,0,0,0-1387.565-1187.846Zm-2.961,29.049-9.084-8.549,4.542-4.245,4.542,4.275,10.212-9.542,4.574,4.274Z",
    transform: "translate(1440.279 1232.45)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpecificationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/specification-icon.d4727b4b.svg";
export { ForwardRef as ReactComponent };